module.exports = __webpack_public_path__ + "img/30.1.f314110e.jpg";